const TESTING_PLACE_SCHEDULE_STATUS = {
  field: {
    join: 1,
    joined: 2,
    completed: 6,
    reject: 7,
    delete: 8,
    deleted: 9,
  },
  value: [
    1, // join
    2, // joined
    6, // completed
    7, // reject
    8, // delete
    9, // deleted
  ],
  used: [1, 2, 6],
  unused: [7, 8, 9],
  name: {
    1: '작성',
    2: '제출',
    6: '확정',
    7: '보류',
    8: '삭제',
    9: '거절'
  },
};

module.exports = TESTING_PLACE_SCHEDULE_STATUS;